import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { useNavigate } from "react-router-dom";
import "jspdf-autotable";
import { getLocalFranchiseStore, getStoreLocalData, getUserData } from "../../../utils/localStorage";
import { getBrandStore } from "../../../services/StoreUsers/PostStoreUsers";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import {
    getBrandReports,
    postReportsView,
} from "../../../services/GarmentStock/Report";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import StoreFilterModal from "../../StoreFilterModal";
import { InputText } from "primereact/inputtext";
import { customerSearch } from "../../../services/SearchAPI/SearchCustomer";
import SingleStoreFilterModal from "../../SingleStoreFilterModal";
import { Checkbox } from "primereact/checkbox";
import { localeDateEndDate, localeDateStartDate } from "../../../constants/DateUtil/DateUtil";
const { innerWidth: width, innerHeight: height } = window;


const FinanceReportsView = () => {
    const navigate = useNavigate();

    const [brandUsersData, setBrandUsersData] = useState([]);
    const [brandReportsDataValue, setBrandReportsDataValue] = useState("");
    const [carryForwardFilterValue, setCarryForwardFilterValue] = useState("carryForward");

    const [reportsViewDataName, setReportsViewDataName] = useState([]);

    const { storeLocalData } = getStoreLocalData();
    const countryCode = storeLocalData?.countryCode;
    const taxType = storeLocalData?.taxType;

    const [reportsViewData, setReportsViewData] = useState({});
    const [reportsViewDataForExcel, setReportsViewDataForExcel] = useState({});
    const { userProfileData, brandProfileData, userProfileRole } = getUserData();
    let brandId = brandProfileData.id;
    let logInUserId = userProfileData.id;
    const userRole = userProfileRole;

    const [loading, setLoading] = useState(false);
    const [brandReportsData, setBrandReportsData] = useState([]);

    const carryForwardFilter = [
        { name: "Carry Forward", value: "carryForward" },
        { name: "Left Carry Forward", value: "leftCarryForward" },
        { name: "Not Carry Forward", value: "notCarryForward" },
    ]

    const [storeSelectionModalVisible, setStoreSelectionModalVisible] =
        useState(false);
    const [
        singleStoreSelectionModalVisible,
        setSingleStoreSelectionModalVisible,
    ] = useState(false);

    let initialStartDate = new Date();
    const [startDate, setStartDate] = useState(new Date(initialStartDate));

    let initialEndDate = new Date();
    const [endDate, setEndDate] = useState(new Date(initialEndDate));

    const [singleSelectedStore, setSingleSelectedStore] = useState("");

    const receiveDataFromStoreSelectionModal = (selectedStore) => {
        setSelectedStore(selectedStore);
    };

    const receiveDataFromSingleStoreSelectionModal = (selectedStore) => {
        setSingleSelectedStore(selectedStore);
    };

    const [searchTerm, setSearchTerm] = useState("");
    const [searchTimeout, setSearchTimeout] = useState(null);
    const [upDateSelectedStore, setUpDateSelectedStore] = useState([]); // Default to show all orders
    const [brandStoreData, setBrandStoreData] = useState([]);
    const [selectedStore, setSelectedStore] = useState("ALL");
    const [filteredData, setFilteredData] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null); // Track selected item

    const fetchBrandReports = (brandReportId) => {
        getBrandReports(brandReportId)
            .then((response) => {
                if (!response.data.error) {
                    const ResFilter = response.data.filter((item) => item.reportName === "Sales" || item.reportName === "Tax" || item.reportName === "Collection" || item.reportName === "Customer Outstanding" || item.reportName === "Package Subscription Report" || item.reportName === "Garment Stock");
                    const Res = ResFilter.map((item, index) => ({
                        name: item.reportName === "Order Detail Subscription Package Report" ? "Order Report Type 3" : item.reportName,
                        id: index,
                        code: item.id,
                    }));
                    setBrandReportsData(Res);
                }
            })
            .catch((err) => {
                console.error("Error:", err);
            });
    };

    const fetchBrandStoreInfo = () => {
        getBrandStore(brandId)
            .then((response) => {
                if (!response.data.error) {
                    const Res = response.data;
                    const storeIds = Res.map((item) => item.id);
                    setBrandUsersData(storeIds);
                    setBrandStoreData(Res);
                }
            })
            .catch((err) => {
                console.error("Error:", err);
            });
    };

    const fetchFranchiseStore = async () => {
        const franchiseStore = await getLocalFranchiseStore();
        if (franchiseStore.franchiseStore !== null) {
            const Res = franchiseStore.franchiseStore.filter((item) => item.status === "ACTIVE");
            const storeIds = Res.map((item) => item.id);
            setBrandStoreData(Res);
            setBrandUsersData(storeIds);
        } else {
            setBrandStoreData([]);
            setBrandUsersData([]);
        }
    };


    useEffect(() => {
        fetchBrandReports(logInUserId);

        if (userRole === "BY_FRANCHISE_ADMIN") {
            fetchFranchiseStore();
        } else {
            fetchBrandStoreInfo();
        }
    }, []);

    const brandCreationDate = brandProfileData.createdDate;

    const [minimumDate, setMinimumDate] = useState(new Date(brandCreationDate));
    const [maximumDate, setMaximumDate] = useState(new Date());

    const handleReportSelection = (selectedItem) => {
        setBrandReportsDataValue(selectedItem);
        if (selectedItem.name === "Next Delivery") {
            const minDate = new Date();
            minDate.setDate(minDate.getDate() + 1);
            setStartDate(minDate);
            setEndDate(minDate);
            setMinimumDate(minDate);
            setMaximumDate(minDate);
        } else {
            setStartDate(initialStartDate);
            setEndDate(initialEndDate);
            setMinimumDate(new Date(brandCreationDate));
            setMaximumDate(new Date());
        }
    };


    const handleReportCarryForwardFilter = (selectedItem) => {
        setCarryForwardFilterValue(selectedItem);

        setStartDate(initialStartDate);
        setEndDate(initialEndDate);
        setMinimumDate(new Date(brandCreationDate));
        setMaximumDate(new Date());

    };

    const handleStartDateChange = (selectedDate) => {
        if (selectedDate) {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Remove time for proper comparison

            const minEndDate = new Date();
            minEndDate.setMonth(minEndDate.getMonth() - 3);
            minEndDate.setDate(minEndDate.getDate() - 1);
            const utcDate = new Date(
                Date.UTC(
                    selectedDate.getFullYear(),
                    selectedDate.getMonth(),
                    selectedDate.getDate()
                )
            );

            const maxEndDate = new Date(utcDate);
            maxEndDate.setMonth(maxEndDate.getMonth() + 3);
            maxEndDate.setDate(maxEndDate.getDate() - 1);
            if (utcDate > today) {
                alert("Start date cannot be a future date.");
            } else if (utcDate > minEndDate && utcDate <= today) {
                // alert("End date selection");
                setStartDate(utcDate);
                setMaximumDate(new Date());
            } else {
                setStartDate(utcDate);
                setEndDate(maxEndDate);
                setMaximumDate(maxEndDate);
            }
        }
    };

    const handleEndDateChange = (selectedDate) => {
        if (selectedDate) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const utcDate = new Date(
                Date.UTC(
                    selectedDate.getFullYear(),
                    selectedDate.getMonth(),
                    selectedDate.getDate()
                )
            );

            if (utcDate > today) {
                alert("End date cannot be a future date.");
                return;
            }

            if (!startDate) {
                alert("Please select a start date first.");
                return;
            }

            const maxEndDate = new Date(startDate);
            maxEndDate.setMonth(maxEndDate.getMonth() + 3);
            maxEndDate.setDate(maxEndDate.getDate() - 1);

            if (utcDate > maxEndDate) {
                alert("End date cannot be more than 3 Month from start date.");
                return;
            }

            setEndDate(utcDate);
        }
    };

    const formatHeader = (key) => {
        return key
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            .replace(/^./, (str) => str.toUpperCase())
            .replace("GSTA", "GST A")
            .replace("Gst Amount", `${taxType} Amount`)
            .replace("Customer Gst No", `Customer ${taxType} No`)
            .replace("Total GST Amount", `Total ${taxType} Amount`);
    };

    const exportExcel = () => {
        import("xlsx").then((xlsx) => {
            const worksheet = xlsx.utils.json_to_sheet(reportsViewDataForExcel);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer = xlsx.write(workbook, {
                bookType: "xlsx",
                type: "array",
            });

            saveAsExcelFile(excelBuffer, reportsViewDataName[0]);
        });
    };

    const saveAsExcelFile = (buffer, fileName) => {
        import("file-saver").then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                let EXCEL_EXTENSION = ".xlsx";
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE,
                });

                module.default.saveAs(
                    data,
                    fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
                );
            }
        });
    };

    const renderCardItem = (data) => {
        if (!data || data.length === 0) return <p>No Data Available</p>;

        const formatDate = (dateString) => {
            if (!dateString) return ""; // Handle empty values
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return ""; // Handle invalid dates

            return date.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
        };

        const columns = Object.keys(data[0]); // Extract column names dynamically

        return (
            <DataTable
                showGridlines
                value={data}
                paginator
                rows={100}
                rowsPerPageOptions={[100, 200, 300]}
                scrollable
                scrollHeight={height - 200}
                tableStyle={{ minWidth: "50rem" }}
            >
                {columns.map((col, index) => (
                    <Column
                        key={index}
                        field={col}
                        header={col
                            .replace(/([a-z])([A-Z])/g, "$1 $2")
                            .replace(/^./, (str) => str.toUpperCase())
                            .replace("GSTA", "GST A")
                            .replace("Gst Amount", `${taxType} Amount`)
                            .replace("Customer Gst No", `Customer ${taxType} No`)
                            .replace("Total GST Amount", `Total ${taxType} Amount`)
                        }
                        body={(rowData) => {
                            if (
                                [
                                    "orderDate",
                                    "orderOn",
                                    "deliveryOn",
                                    "deliveredOn",
                                    "packageLastRechargeDate",
                                    "bookingOn",
                                    "deliverDate",
                                    "paymentDate",
                                    "billDate",
                                    "dueDate",
                                    "subscribedOn",
                                    "resubscribedOn",
                                    "validFrom",
                                    "validTo",
                                    "validOn"
                                ].includes(col)
                            ) {
                                const formattedDate = formatDate(rowData[col]);
                                return formattedDate === "01/01/1970" ? "" : formattedDate;
                            }
                            return rowData[col];
                        }}
                    />
                ))}
            </DataTable>
        );
    };

    const handleChange = (text) => {
        // If user types something after selection, clear selectedItem
        if (selectedItem) {
            setSelectedItem(null);
        }
        handleAllData(text);
    };

    // const handleAllData = (inputValue) => {
    //   const copyNumber = inputValue.startsWith(countryCode)
    //     ? inputValue.replace(new RegExp(`^${countryCode}\\s*|\\s+`, "g"), "")
    //     : inputValue;

    //   setSearchTerm(copyNumber);

    //   if (searchTimeout) {
    //     clearTimeout(searchTimeout);
    //   }
    //   setSearchTimeout(
    //     setTimeout(() => {
    //       handleSearch(copyNumber);
    //     }, 50)
    //   );
    // };

    const handleAllData = (inputValue) => {
        const escapeRegex = (str) =>
            str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

        const escapedCountryCode = escapeRegex(countryCode);

        const copyNumber = inputValue.startsWith(countryCode)
            ? inputValue.replace(
                new RegExp(`^${escapedCountryCode}\\s*|\\s+`, "g"),
                ""
            )
            : inputValue.replace(/\s+/g, " ");

        setSearchTerm(copyNumber);

        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        setSearchTimeout(
            setTimeout(() => {
                handleSearch(copyNumber);
            }, 50)
        );
    };

    const handleSearch = async (text) => {
        if (text) {
            const storeIdData = singleSelectedStore[0] || brandUsersData[0];
            const newData = {
                storeId: singleSelectedStore[0] || brandUsersData[0],
                searchText: text,
                searchBy: "",
                maxLimit: 50,
            };
            try {
                const response = await customerSearch(storeIdData, newData);
                if (!response.data.error) {
                    const Res = response.data;
                    const brandCustomerFirstNames = Res.map((item) => ({
                        id: item.id,
                        firstName: item.brandCustomer.firstName,
                        lastName: item.brandCustomer.lastName
                            ? item.brandCustomer.lastName
                            : "",
                        email: item.brandCustomer.email,
                        mobile: item.brandCustomer.mobile,
                        customerId: item.brandCustomer.customerId,
                        ...item,
                    }));

                    setFilteredData(brandCustomerFirstNames);
                    // setSearchTerm(text);
                }
            } catch (error) {
                console.error("Error:", error);
            }
        }
    };

    const handleItemPress = (item) => {
        setSelectedItem(item);
    };

    const [isReportMail, setIsReportMail] = useState(false)

    const handleReportSend = () => {
        setLoading(true);
        // const convertToUTC = (date) => {
        //   if (!date || !(date instanceof Date)) {
        //     console.error("Invalid date:", date);
        //     return null;
        //   }
        //   const offset = date.getTimezoneOffset();
        //   return new Date(date.getTime() - offset * 60 * 1000 + 1000).toISOString();
        // };

        // const currentDateTimeStartDate = convertToUTC(startDate);
        // const currentDateTimeEndDate = convertToUTC(endDate);

        const currentDateTimeStartDate = startDate.toISOString();
        const currentDateTimeEndDate = endDate.toISOString();

        const data = {
            brandIds: [brandId],
            storeIds: selectedStore !== "ALL" ? selectedStore : brandUsersData,
            statusIn:
                brandReportsDataValue.code === 6
                    ? ["DELIVERED"]
                    : [
                        "BOOKED",
                        "INPROCESS",
                        "IN_WAREHOUSE",
                        "OUT_FOR_DELIVERY",
                        "PROCESSED",
                        "DELAY",
                        "DELIVERED",
                        "DONE",
                    ],
            storeCustomerIds: selectedItem?.id ? [selectedItem?.id] : null,
            generatedReportName: selectedItem?.id ? selectedItem?.firstName + selectedItem?.lastName + "_" + selectedItem.mobile : null,
            startDate: localeDateStartDate(new Date(currentDateTimeStartDate)),
            endDate: localeDateEndDate(new Date(currentDateTimeEndDate)),
            reportIds: [brandReportsDataValue.code],
            requestBy: logInUserId,
            reportGenerate: isReportMail,
            reportMail: isReportMail,
            recordType: carryForwardFilterValue,
        };

        // Define key orders for different report types
        const keyOrders = {
            Sales: [
                "orderDate",
                "invoiceNo",
                "orderNo",
                "storeName",
                "customerName",
                "customerMobile",
                "status",
                "grossAmount",
                "charges",
                "bookingDiscount",
                "subscriptionDiscount",
                "taxableAmount",
                "gstAmount",
                "netAmount",
                "deliveryDiscount",
                "loyaltyPointDiscount",
                "payableAmount",
                "remarks",
                "deliveryRemarks",
                "orderSource",
            ],
            Tax: [
                // "orderId",
                "orderDate",
                "storeName",
                "orderNo",
                "invoiceNo",
                "customerName",
                "customerMobile",
                "customerGstNo",
                "status",
                "gstAmount",
                "orderAmount",
                "remarks",
                "deliveryRemarks",
                "orderSource",
            ],
            Order: [
                // "orderId",
                "orderDate",
                "deliverDate",
                "invoiceNo",
                "orderNo",
                "storeName",
                "customerName",
                "customerMobile",
                "status",
                "orderAmount",
                "discount",
                "receivedAmount",
                "remarks",
                "deliveryRemarks",
                "orderSource",
            ],
            Collection: [
                // "orderId",
                // "paymentId",
                "paymentDate",
                "orderNo",
                "invoiceNo",
                "storeName",
                "customerName",
                "customerMobile",
                "orderAmount",
                "payment",
                "balanceAmount",
                "paymentMode",
                "paymentStatus",
                // "receivedBy",
            ],
            "Pending Revenue": [
                // "orderId",
                "orderNo",
                "invoiceNo",
                "storeName",
                "customerName",
                "customerMobile",
                "status",
                "orderAmount",
                "balanceAmount",
                "remarks",
                "deliveryRemarks",
            ],

            "Delay Delivery Garment": [
                "orderNo",
                "invoiceNo",
                "orderOn",
                "deliveryOn",
                "customerName",
                "customerMobile",
                "status",
                "garment",
                "count",
                "homeDelivery",
                "remarks",
            ],
            "Order Summary": [
                "orderDate",
                "deliverDate",
                "orderNo",
                "invoiceNo",
                "storeName",
                "customerName",
                "customerMobile",
                "status",
                "orderAmount",
                "receivedAmount",
                "discount",
                "remarks",
                "deliveryRemarks",
                "orderSource",
            ],

            "Next Delivery": [
                "orderNo",
                "invoiceNo",
                "orderOn",
                "deliveryOn",
                "customerName",
                "customerMobile",
                "status",
                "garment",
                "count",
                "homeDelivery",
                "remarks",
            ],
            "Garment Stock": [
                "invoiceNo",
                "bookingOn",
                "deliveryOn",
                "garmentName",
                "itemGarmentCount",
                "garmentQRCount",
                "garmentStatus",
                "orderStatus",
            ],
            "Customer Wise Revenue": [
                "customerMobile",
                "customerId",
                "customerName",
                "orderCount",
                "totalGarment",
                "totalGrossAmount",
                "totalGSTAmount",
                "totalGrandAmount",
            ],

            // "Order Detail Subscription Package Report": [
            "Order Report Type 3": [
                "storeName",
                "orderDate",
                "invoiceNo",
                "customerId",
                "customerName",
                "customerMobile",
                "customerAddress",
                "deliveryOn",
                "deliveredOn",
                "itemGarmentCount",
                "itemGarmentWeight",
                "grossAmount",
                "discount",
                "netAmount",
                "amountReceived",
                "amountSettled",
                "balanceAmount",
                "advance",
                "advanceUsed",
                "orderCreatedBy",
                "rackInfo",
                "packageUsed",
                "packageName",
                "packageAvailableBalance",
                "packageLastRechargeDate",
                "serviceName",
                "status",
                "remarks",
                "deliveryRemarks",
                "orderSource",
            ],
            "Package Subscription Report": [
                "storeName",
                "customerName",
                "customerMobile",
                "customerAddress",
                "packageName",
                "subscribedOn",
                "serviceValue",
                "packageValue",
                "paymentMode",
                "leftPackageValue",
                "validity",
                "subscriptionAmount",
                "resubscribedOn",
                "validFrom",
                "validTo",
            ],

            "Package Carry Forward Report": [
                "storeName",
                "customerName",
                "customerMobile",
                "customerAddress",
                "packageName",
                "carryForwardCount",
                "carryForwardInvoiceNo",
                "carryForward",
                "packageCount",
                "countGram",
                "packageCount",
                "itemCount",
                "validOn",
            ],
        };

        postReportsView(data)
            .then((response) => {
                if (!response.data.error) {
                    const Res = response.data;

                    // Special handling for "Service Wise Revenue"
                    if (brandReportsDataValue.name === "Service Wise Revenue") {
                        const rawReport = Res.serviceWiseRevenueReport || {};
                        const serviceKeysSet = new Set();

                        // Step 1: Collect all unique service names
                        for (const services of Object.values(rawReport)) {
                            Object.keys(services).forEach((service) =>
                                serviceKeysSet.add(service)
                            );
                        }

                        const serviceKeys = Array.from(serviceKeysSet);
                        const reportTable = [];

                        // Step 2: Initialize summary row
                        const summaryRow = Object.fromEntries(
                            serviceKeys.map((key) => [key, 0])
                        );
                        summaryRow["Total"] = 0;

                        const sortedEntries = Object.entries(rawReport).sort(
                            ([a], [b]) => new Date(a) - new Date(b)
                        );

                        // Step 3: Process each date
                        // for (const [date, services] of Object.entries(rawReport)) {
                        for (const [date, services] of sortedEntries) {
                            const formattedDate = new Date(date).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                            });

                            const row = { Date: formattedDate };

                            let rowTotal = 0;
                            for (const key of serviceKeys) {
                                const value = services[key] || 0;
                                row[key] = value;
                                rowTotal += value;
                                summaryRow[key] += value;
                            }

                            row["Total"] = parseFloat((rowTotal).toFixed(2));
                            summaryRow["Total"] += parseFloat((rowTotal).toFixed(2));

                            reportTable.push(row);
                        }

                        // Step 4: Push summary row
                        reportTable.push({ Date: "Total", ...summaryRow });

                        // Step 5: Send to state
                        setReportsViewData(reportTable);
                        setReportsViewDataForExcel(reportTable);
                        setReportsViewDataName(["Service Wise Revenue"]);
                        setLoading(false);
                        setSelectedItem(null)
                        setFilteredData([]);
                        setSearchTerm("");
                        return;
                    }

                    // Special handling for "Service Wise Revenue"
                    if (brandReportsDataValue.name === "Garment Wise Revenue") {
                        const rawReport = Res.garmentWiseRevenueReport || {};
                        const garmentKeysSet = new Set();

                        // Step 1: Collect all unique garments names
                        for (const garments of Object.values(rawReport)) {
                            Object.keys(garments).forEach((garment) =>
                                garmentKeysSet.add(garment)
                            );
                        }

                        const garmentKeys = Array.from(garmentKeysSet);
                        const reportTable = [];

                        // Step 2: Initialize summary row
                        const summaryRow = Object.fromEntries(
                            garmentKeys.map((key) => [key, 0])
                        );
                        summaryRow["Total"] = 0;

                        const sortedEntries = Object.entries(rawReport).sort(
                            ([a], [b]) => new Date(a) - new Date(b)
                        );

                        // Step 3: Process each date
                        // for (const [date, garments] of Object.entries(sortedEntries)) {
                        for (const [date, garments] of sortedEntries) {
                            const formattedDate = new Date(date).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                            });

                            const row = { Date: formattedDate };

                            let rowTotal = 0;
                            for (const key of garmentKeys) {
                                const value = garments[key] || 0;
                                row[key] = value;
                                rowTotal += value;
                                summaryRow[key] += value;
                            }

                            row["Total"] = parseFloat((rowTotal).toFixed(2));
                            summaryRow["Total"] += parseFloat((rowTotal).toFixed(2));

                            reportTable.push(row);
                        }

                        // Step 4: Push summary row
                        reportTable.push({ Date: "Total", ...summaryRow });

                        // Step 5: Send to state
                        setReportsViewData(reportTable);
                        setReportsViewDataForExcel(reportTable);
                        setReportsViewDataName(["Garment Wise Revenue"]);
                        setLoading(false);
                        setSelectedItem(null)
                        setFilteredData([]);
                        setSearchTerm("");
                        return;
                    }

                    // Step 1: Format data
                    const formattedData = Object.values(Res)
                        .flat()
                        .filter(Boolean)
                        .map((item) => {
                            const keyOrder = keyOrders[brandReportsDataValue.name];

                            if (keyOrder) {
                                return Object.fromEntries(
                                    keyOrder.map((key) => [key, item[key] ?? null])
                                );
                            }

                            return item;
                        });

                    // Step 2: Calculate column sums (handles numbers + numeric strings)
                    const excludeKeys = ["orderNo", "customerMobile", "invoiceNo", "customerName", "remarks"];

                    const columnSums = formattedData.reduce((acc, row) => {
                        Object.entries(row).forEach(([key, value]) => {
                            // Skip excluded columns
                            if (excludeKeys.includes(key)) return;

                            const num = Number(value);

                            if (!isNaN(num) && value !== null && value !== "") {
                                acc[key] = (acc[key] || 0) + num;
                            }
                        });

                        return acc;
                    }, {});

                    const keyOrder =
                        keyOrders[brandReportsDataValue.name] ||
                        Object.keys(formattedData[0] || {});

                    // choose a better column for "Total"
                    const labelKey =
                        keyOrder.find((k) =>
                            ["customerName", "customerMobile", "storeName", "orderNo", "Payment Date", "invoiceNo",].includes(k)
                        ) || keyOrder[0];

                    const totalRow = {};

                    keyOrder.forEach((key) => {
                        if (key === labelKey) {
                            totalRow[key] = "Total";
                        } else {
                            totalRow[key] = columnSums[key] ?? "";
                        }
                    });
                    // Step 4: Filter keys
                    const filteredKeys = Object.keys(Res).filter(
                        (key) => Res[key] !== null
                    );

                    setReportsViewDataName(filteredKeys);

                    // Step 5: Set table data (with total row)
                    setReportsViewData([...formattedData, totalRow]);

                    // Step 6: Excel formatting (include total row too)
                    const formattedForExcel = [...formattedData, totalRow].map((row) =>
                        Object.fromEntries(
                            Object.entries(row).map(([key, value]) => [
                                formatHeader(key),
                                value,
                            ])
                        )
                    );

                    setReportsViewDataForExcel(formattedForExcel);

                    setLoading(false);
                }
                setSelectedItem(null)
                setFilteredData([]);
                setSearchTerm("");

            })
            .catch((err) => {
                console.error("Error:", err);
                setLoading(false);
            });
    };

    return (
        <div className="flex-1">
            <div
                className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
                style={{
                    "--surface-0": "#1752AA",
                }}
            >
                <div className="flex-1 flex ml-3 mr-3">
                    <div className="flex-1 flex ">
                        <div className="ml-3 flex justify-content-center align-items-center">
                            <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                                <i
                                    className="pi pi-angle-left"
                                    onClick={() => navigate("/")}
                                    style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                                ></i>
                            </div>
                        </div>
                        <div className="flex-1 ml-5">
                            <p className="text-white text-2xl font-bold uppercase">
                                {reportsViewDataName.length > 0
                                    ? reportsViewDataName[0]
                                        .replace(/([a-z])([A-Z])/g, "$1 $2")
                                        .replace(/^./, (str) => str.toUpperCase())
                                    : "Reports"}
                            </p>
                        </div>
                        <div
                            onClick={() => setStoreSelectionModalVisible(true)}
                            className="mx-2 cursor-pointer"
                        >
                            <img
                                src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
                                style={{ width: 30 }}
                                alt="filter"
                            />
                        </div>
                        <div className="flex justify-content-center align-items-center mx-4">
                            <div className="flex justify-content-between align-items-center">
                                {brandReportsDataValue && (
                                    <div className="flex flex-1 justify-content-between my-1">
                                        <p className="text-xl font-medium text-white mr-3">
                                            Sent To Mail
                                        </p>
                                        <div>
                                            <Checkbox
                                                checked={isReportMail}
                                                size="20" // Increased size
                                                color={isReportMail ? "#00A3FF" : "#C1C9D3"}
                                                onClick={() => setIsReportMail(!isReportMail)}
                                            />
                                        </div>
                                    </div>
                                )}
                                {/* <div
                    onClick={() => handleReportSend(true)}
                    className="w-full flex justify-content-between border-round-lg px-4 py-1 cursor-pointer"
                    style={{
                      color: "#fff",
                      backgroundColor: "green",
                      borderColor: "green",
                    }}
                  >
                    <p className=" w-full text-xl font-semibold flex justify-content-center">
                      Sent To Mail
                    </p>
                  </div> */}

                                {/* <p
                  className="text-lg font-medium mx-2"
                  style={{ color: "#fff" }}
                >
                  Sent To Mail
                </p>
                <div>
                  <Checkbox
                    checked={reportMail}
                    color={reportMail ? "#00A3FF" : "#C1C9D3"}
                    onClick={() => setReportMail(!reportMail)}
                    size={20}
                  /> 
                </div>*/}
                            </div>
                        </div>
                        {reportsViewData.length > 0 && (
                            <div className="flex justify-content-center align-items-center">
                                <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
                                    <img
                                        onClick={exportExcel}
                                        src={"images/file.png"}
                                        style={{
                                            width: 30,
                                        }}
                                        alt="file"
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div>
                <div className="mx-4 mt-1 my-1">
                    <div>
                        <div className="flex-1 mx-1 flex">
                            <div className="flex-1 mx-1 ">
                                <p className="font-bold block mb-1 ml-2">Report Selection</p>
                                <Dropdown
                                    value={brandReportsDataValue}
                                    onChange={(e) => handleReportSelection(e.value)}
                                    options={brandReportsData}
                                    optionLabel="name"
                                    placeholder="Search Reports"
                                    className="w-full  bg-white-alpha-20 border-round-lg p-0 text-lg text-primary-50"
                                />
                            </div>
                            {brandReportsDataValue.name === "Package Carry Forward Report" && (
                                <div className="flex-1 mx-1 ">
                                    <p className="font-bold block mb-1 ml-2">Carry Forward Bills</p>
                                    <Dropdown
                                        value={carryForwardFilterValue}
                                        onChange={(e) => handleReportCarryForwardFilter(e.value)}
                                        options={carryForwardFilter}
                                        optionLabel="name"
                                        placeholder="Search Filter"
                                        className="w-full  bg-white-alpha-20 border-round-lg p-0 text-lg text-primary-50"
                                    />
                                </div>
                            )}
                            {brandReportsDataValue.name === "Garment Wise Revenue" && (
                                <>
                                    {brandUsersData.length > 1 && (
                                        <div
                                            onClick={() => setSingleStoreSelectionModalVisible(true)}
                                            className="mx-2 cursor-pointer text-center"
                                        >
                                            <p className="font-bold block mb-1 ml-2">Select store</p>
                                            <img
                                                src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
                                                style={{ width: 30 }}
                                                className="mt-2"
                                                alt="filter"
                                            />
                                        </div>
                                    )}
                                    <div className="flex-1 mx-1">
                                        <p className="font-bold block mb-1 ml-2">Search Customer</p>
                                        <InputText
                                            value={
                                                selectedItem
                                                    ? `${selectedItem.firstName} ${selectedItem.lastName}`
                                                    : searchTerm
                                            }
                                            placeholder="Search Users By Name, Mobile, Etc."
                                            maxLength={100}
                                            className="w-full bg-white-alpha-50 border-round-lg p-2 text-lg"
                                            autoFocus
                                            onChange={(e) => handleChange(e.target.value)}
                                        />
                                    </div>
                                </>
                            )}
                            <div className="flex-1">
                                <p className="font-bold block ml-2">Start Date</p>
                                <Calendar
                                    id="buttondisplay"
                                    value={startDate}
                                    onChange={(e) => handleStartDateChange(e.value)}
                                    showIcon
                                    minDate={minimumDate}
                                    maxDate={new Date()}
                                    className="w-full  bg-white-alpha-20 border-round-lg p-1 text-lg text-primary-50"
                                    dateFormat="dd/mm/yy"
                                />
                            </div>

                            <div className="flex-1">
                                <p className="font-bold block ml-2">End Date</p>
                                <Calendar
                                    id="buttondisplay"
                                    value={endDate}
                                    onChange={(e) => handleEndDateChange(e.value)}
                                    showIcon
                                    minDate={startDate}
                                    maxDate={maximumDate}
                                    className="w-full  bg-white-alpha-20 border-round-lg p-1 text-lg text-primary-50"
                                    dateFormat="dd/mm/yy"
                                />
                            </div>
                            <div className="flex justify-content-center align-items-end">
                                {brandReportsDataValue && (
                                    <Button
                                        onClick={() => handleReportSend()}
                                        className=" mx-4 border-round-xl py-2"
                                        style={{ bottom: 10 }}
                                    >
                                        <p className=" w-full text-2xl font-semibold flex justify-content-center">
                                            Get Report
                                        </p>
                                    </Button>
                                )}
                            </div>
                        </div>
                    </div>
                    {loading ? (
                        <div className="flex flex-1 flex-column justify-content-center align-items-center">
                            <ProgressSpinner />
                            <p className="text-3xl font-bold">Loading Report Data...</p>
                        </div>
                    ) : reportsViewData.length > 0 ? (
                        <div className="mx-2 my-2 report-table">
                            {renderCardItem(reportsViewData)}
                        </div>
                    ) : (
                        <div>
                            <div className="my-4 flex justify-content-center">
                                <p className="text-xl font-medium">
                                    No Data Found! Please Select Report
                                </p>
                            </div>
                            {brandReportsDataValue.name === "Garment Wise Revenue" && (
                                <div className="my-4 flex justify-content-center">
                                    <p className="text-xl font-medium">
                                        {brandUsersData.length > 1
                                            ? "Please Select Store and then search customer"
                                            : "Please Search Customer"}
                                    </p>
                                </div>
                            )}
                        </div>
                    )}

                    {searchTerm &&
                        brandReportsDataValue.name === "Garment Wise Revenue" &&
                        !selectedItem &&
                        (filteredData.length > 0 ? (
                            filteredData.map((item) => (
                                <div
                                    key={item.id}
                                    className="px-5 py-2 border-bottom-1 flex justify-content-between"
                                    style={{ borderBottomColor: "#D2DBD6", cursor: "pointer" }}
                                    onClick={() => handleItemPress(item)}
                                >
                                    <p className="text-lg uppercase" style={{ color: "#75879B" }}>
                                        {item.firstName} {item.lastName}, {item.mobile}
                                    </p>
                                    {selectedItem?.id === item.id && (
                                        <i
                                            className="pi pi-check"
                                            style={{ fontSize: "20px", color: "#008EFF" }}
                                        ></i>
                                    )}
                                </div>
                            ))
                        ) : (
                            <div className="flex justify-content-center align-items-center flex-column">
                                <div className="my-5">
                                    <img
                                        style={{ width: "100%", height: "250px" }}
                                        src="/Laundy_App_Icons_Gifs/Search_Empty.gif"
                                        alt="logo"
                                    />
                                </div>
                                <div className="flex justify-content-center align-items-center flex-column">
                                    <h4 className=" text-3xl font-bold">
                                        Your Search Result is Empty!
                                    </h4>
                                    <div>
                                        <p className=" text-xl font-normal">
                                            You haven't searched any user till now! Find
                                            customers/users to check their results
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
            <StoreFilterModal
                setStoreFilterModalVisible={setStoreSelectionModalVisible}
                storeFilterModalVisible={storeSelectionModalVisible}
                sendDataToOrdersPageFromFilter={receiveDataFromStoreSelectionModal}
                upDateSelectedStore={upDateSelectedStore}
                brandStoreData={brandStoreData}
            />
            <SingleStoreFilterModal
                setSingleStoreFilterModalVisible={setSingleStoreSelectionModalVisible}
                singleStoreFilterModalVisible={singleStoreSelectionModalVisible}
                sendDataToOrdersPageFromFilter={
                    receiveDataFromSingleStoreSelectionModal
                }
                upDateSelectedStore={upDateSelectedStore}
                brandStoreData={brandStoreData}
            />
        </div>
    );
};

export default FinanceReportsView;
